import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styles from "./tagList.module.scss"

const TagList= ({ tag }) => (
  <div className={styles.TagList}>
    {tag.map(t => {
      return <Link to={`/tag/${t.slug}/`}><div  className={styles.tag}>{t.name}</div></Link>
    })}
  </div>
)

TagList.propTypes = {
  tag: PropTypes.array,
}

TagList.defaultProps = {
  tag: { name: {}, slug: ''},
}

export default TagList
